import dayjs from 'dayjs';
import 'dayjs/locale/fr';

import type { EcheanceDataType } from '@/types';
import TileBase from './TileBase';
import TileHeader from './TileHeader';

dayjs.locale('fr');

type EcheanceItemPropsType = {
  label: string;
  overdueLabel: string;
  echeance: EcheanceDataType | null;
};

const EcheanceItem = ({ label, overdueLabel, echeance }: EcheanceItemPropsType) => {
  const joursRestants = echeance?.joursRestants ?? 0;
  const isUrgent = echeance?.isUrgent ?? false;
  const isOverdue = echeance?.isOverdue ?? false;

  if (isOverdue) {
    return (
      <div className="echeance-item urgent overdue">
        <div className="echeance-item-jours">-</div>
        <div className="echeance-item-content">
          <span className="echeance-item-label">
            <b>{`${overdueLabel} à réaliser !`}</b>
          </span>
        </div>
      </div>
    );
  }

  const dateFormatted = echeance?.date ? dayjs(echeance.date).format('DD/MM/YYYY') : null;

  // Accord singulier/pluriel : 0-1 = "jour", 2+ = "jours"
  const jourLabel = joursRestants <= 1 ? 'jour' : 'jours';

  return (
    <div className={`echeance-item ${isUrgent ? 'urgent' : ''}`}>
      <div className="echeance-item-jours">{joursRestants}</div>
      <div className="echeance-item-content">
        <span className="echeance-item-label">
          {dateFormatted ? (
            <>
              {`${jourLabel} ${label}, le `}
              <strong>{dateFormatted}</strong>
            </>
          ) : (
            `${jourLabel} ${label} (non configuré)`
          )}
        </span>
      </div>
    </div>
  );
};

type TileEcheancesPropsType = {
  echeanceArrete: EcheanceDataType | null;
  echeanceVersement: EcheanceDataType | null;
  loading?: boolean;
};

const TileEcheances = ({ echeanceArrete, echeanceVersement, loading }: TileEcheancesPropsType) => {
  // La tuile passe en mode urgent si une échéance < 7 jours
  const isUrgent = echeanceArrete?.isUrgent || echeanceVersement?.isUrgent;

  return (
    <TileBase className={`tile-echeances ${isUrgent ? 'urgent' : ''}`} loading={loading}>
      <TileHeader title="Prochaines échéances" />

      <div className="tile-echeances-list">
        <EcheanceItem
          label="avant l'arrêté de la régie"
          overdueLabel="Arrêté de régie"
          echeance={echeanceArrete}
        />
        <EcheanceItem
          label="avant le versement de l'encaisse"
          overdueLabel="Versement de l'encaisse"
          echeance={echeanceVersement}
        />
      </div>
    </TileBase>
  );
};

export default TileEcheances;
